$(document).ready(function(){
  $('body').on('click','.CartItem__Remove, .quantity-minus',function(){
 
 // $('div#sidebar-cart').addClass('blockcartbtn');
    $('.checkboxGift').removeClass('displayNone');
    
});
  
  $('body').on('click', '#up_icon', function() {
    $(this).toggleClass('active');
    $(".cart-shipping-description").toggle('slow');
  });
});
  const clearCartButton = document.getElementById('clear-cart-button');
  const cartDrawer = document.querySelector('.CartItemWrapper');
// clearCartButton.addEventListener('click', () => {
$('body').on('click','#clear-cart-button',function(){
  $('.ProductForm__AddToCart').attr('cartitems',0);
  // alert();
  fetch('/cart/clear.js')
  .then(response => response.json())
  .then((data)=>{
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
  })
  .catch((err) => console.log("err>>>",err));
  // var xhrClearCart = new XMLHttpRequest();
  // xhrClearCart.open('POST', '/cart/clear.js', true);

  // xhrClearCart.onreadystatechange = function () {
  //   if (xhrClearCart.readyState === 4 && xhrClearCart.status === 200) {
  //     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //       bubbles: true
  //     }));
  //   }
  // };

  // xhrClearCart.send();
});


// window.onload = function() {
//     const clearCartButton = document.getElementById('clear-cart-button');
    
//     // Set the button to be visible on page load
//     clearCartButton.style.display = 'block';

//     // Example condition: if cart is empty, hide the button
//     if (/* your condition to check if cart is empty */) {
//         clearCartButton.style.display = 'none';
//     }
// };


